module.exports = __webpack_public_path__ + "static/media/risk.5916ced9.png";